import React, { ReactElement } from 'react';
import moment from 'moment';
import { JobsiteInfo } from 'containers/jobsite/tabs/jobsiteInfo/types';
import { getPrettyFormattedDate } from 'utils/dates';
import { Badge } from '@odin-labs/components';
import { EditJobsiteSettingsButton } from './EditJobsiteSettingsButton';
import { JobsiteInfoBaseCard } from './JobsiteInfoBaseCard';

export type JobsiteInfoCardProps = {
  jobsite?: JobsiteInfo;
  baseRoute: string;
};

export function JobsiteInfoCard({
  jobsite,
  baseRoute,
}: JobsiteInfoCardProps): ReactElement {
  const {
    name,
    jobsiteId,
    addressLine1,
    addressLine2,
    addressCity,
    addressState,
    addressZipCode,
    startDate,
    endDate,
    developer,
  } = jobsite ?? {};

  const cityStateZip = [addressCity, addressState, addressZipCode]
    .filter(Boolean)
    .join(' ');

  const address = (
    <span>
      {addressLine1}
      {addressLine2 && (
        <>
          <br />
          {addressLine2}
        </>
      )}
      {cityStateZip && (
        <>
          <br />
          {cityStateZip}
        </>
      )}
    </span>
  );

  const isSiteActive = !endDate || moment(endDate).isAfter(moment());

  const createdAt = jobsite?.objectHistory?.createdAt;
  const updatedAt = jobsite?.objectHistory?.updatedAt;

  return (
    <JobsiteInfoBaseCard
      label="Site info"
      title={name}
      subtitle={developer?.organization?.name}
      headerActions={
        <>
          <Badge
            color={isSiteActive ? 'green' : 'gray'}
            text={isSiteActive ? 'Active' : 'Inactive'}
          />
          <EditJobsiteSettingsButton
            jobsiteId={jobsiteId}
            baseRoute={baseRoute}
          />
        </>
      }
      fields={[
        { label: 'Address', value: address },
        { label: 'Start date', value: getPrettyFormattedDate(startDate) },
      ]}
      footer={
        <div className="odin-flex odin-flex-col sm:odin-flex-row sm:odin-justify-between odin-gap-1 odin-text-xs odin-text-odin-dark-gray">
          <span>
            Last updated {getPrettyFormattedDate(updatedAt ?? createdAt)}
          </span>
          <span>Created {getPrettyFormattedDate(createdAt)}</span>
        </div>
      }
    />
  );
}
